import {
    AdjustmentUpdateListElementType,
    AdjustmentUpdateType,
    IncomingUpdateListElementType,
    IncomingUpdateType,
    InvHistoryListElementType,
    InvHistoryType,
    OutgoingUpdateListElementType,
    OutgoingUpdateType
} from "../interface";

export const invHistoryInit: InvHistoryType = {
    inventoryChangeRecordId: 0,
    changeType: "",
    code: "",
    accountName: "",
    changeAt: "",
    memo: "",
    modAt: "",
    regBy: 0,
    inventoryChangeResList: []
}

export const invHistoryListElementInit: InvHistoryListElementType = {
    inventoryChangeId: 0,
    inventoryId: 0,
    vendor: "",
    category: "",
    newTxtNmItem: "",
    newTxtStndItem: "",
    inventoryUnit: 0,
    changeAmount: 0,
    changeResult: "",
    initialInventoryAmount: 0,
    newInventoryAmount: 0
}

export const incomingUpdateInit: IncomingUpdateType = {
    accountName: "",
    changeAt: "",
    inventoryChangeRecordId: 0,
    memo: "",
    updateEachIncomingReqList: [],
};

export const incomingUpdateListElementInit: IncomingUpdateListElementType = {
    changeAmount: 0,
    inventoryId: 0,
};

export const outgoingUpdateInit: OutgoingUpdateType = {
    accountName: "",
    changeAt: "",
    inventoryChangeRecordId: 0,
    memo: "",
    updateEachOutgoingReqList: [],
};

export const outgoingUpdateListElementInit: OutgoingUpdateListElementType = {
    changeAmount: 0,
    inventoryId: 0,
};

export const adjustmentUpdateInit: AdjustmentUpdateType = {
    inventoryChangeRecordId: 0,
    memo: "",
    updateEachAdjustmentReqList: [],
};

export const adjustmentUpdateListElementInit: AdjustmentUpdateListElementType = {
    changeAmount: 0,
    inventoryId: 0,
};